import { UserType } from "@/types/IdentityTypes";
export type DashboardSeat = "owner" | "manager";
export const dashboardSeatOf = (type: unknown): DashboardSeat | null =>
  type === UserType.Landlord
    ? "owner"
    : type === UserType.Manager
      ? "manager"
      : null;
export interface SeatRules {
  moneyTileLabel: "Earned" | "Net to owners";
  rowsNameOwners: boolean;
  people: "owners" | "landlords";
  rentByOwner: boolean;
  ownerAnalysis: boolean;
}
export const SEAT_RULES: Record<DashboardSeat, SeatRules> = {
  owner: {
    moneyTileLabel: "Earned",
    rowsNameOwners: false,
    people: "owners",
    rentByOwner: false,
    ownerAnalysis: true,
  },
  manager: {
    moneyTileLabel: "Net to owners",
    rowsNameOwners: true,
    people: "landlords",
    rentByOwner: true,
    ownerAnalysis: false,
  },
};
